/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("hr", {
  Redo: "Ponovi",
  Undo: "Poni\u0161ti",
  Cut: "Izre\u017ei",
  Copy: "Kopiraj",
  Paste: "Zalijepi",
  "Select all": "Odaberi sve",
  "New document": "Novi dokument",
  Ok: "U redu",
  Cancel: "Odustani",
  "Visual aids": "Vizualna pomo\u0107",
  Bold: "Podebljano",
  Italic: "Kurziv",
  Underline: "Podcrtaj",
  Strikethrough: "Prekri\u017ei",
  Superscript: "Eksponent",
  Subscript: "Indeks",
  "Clear formatting": "Izbri\u0161i oblikovanje",
  "Align left": "Poravnaj lijevo",
  "Align center": "Poravnaj po sredini",
  "Align right": "Poravnaj desno",
  Justify: "Obostrano poravnanje",
  "Bullet list": "Popis s oznakama",
  "Numbered list": "Numerirani popis",
  "Decrease indent": "Smanji uvla\u010denje",
  "Increase indent": "Pove\u0107aj uvla\u010denje",
  Close: "Zatvori",
  Formats: "Formati",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Va\u0161 preglednik ne podr\u017eava izravan pristup me\u0111uspremniku. Umjesto toga upotrijebite tipkovni\u010dke pre\u010dace Ctrl\u00a0+\u00a0X/C/V.",
  Headers: "Zaglavlja",
  "Header 1": "Zaglavlje 1",
  "Header 2": "Zaglavlje 2",
  "Header 3": "Zaglavlje 3",
  "Header 4": "Zaglavlje 4",
  "Header 5": "Zaglavlje 5",
  "Header 6": "Zaglavlje 6",
  Headings: "Zaglavlja",
  "Heading 1": "Zaglavlje 1",
  "Heading 2": "Zaglavlje 2",
  "Heading 3": "Zaglavlje 3",
  "Heading 4": "Zaglavlje 4",
  "Heading 5": "Zaglavlje 5",
  "Heading 6": "Zaglavlje 6",
  Preformatted: "Prethodno oblikovano",
  Div: "Div",
  Pre: "Pre",
  Code: "Kod",
  Paragraph: "Odlomak",
  Blockquote: "Blockquote",
  Inline: "U retku",
  Blocks: "Blokovi",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Akcija zalijepi od sada lijepi \u010disti tekst. Sadr\u017eaj \u0107e biti zaljepljen kao \u010disti tekst sve dok ne isklju\u010dite ovu opciju.",
  Fonts: "Fontovi",
  "Font Sizes": "Veli\u010dine fonta",
  Class: "Razred",
  "Browse for an image": "Potra\u017eite sliku",
  OR: "ILI",
  "Drop an image here": "Ispustite sliku ovdje",
  Upload: "U\u010ditaj",
  Block: "Blok",
  Align: "Poravnaj",
  Default: "Zadano",
  Circle: "Krug",
  Disc: "To\u010dka",
  Square: "Kvadrat",
  "Lower Alpha": "Mala slova",
  "Lower Greek": "Mala gr\u010dka slova",
  "Lower Roman": "Mala rimska slova",
  "Upper Alpha": "Velika slova",
  "Upper Roman": "Velika rimska slova",
  "Anchor...": "Fiksna to\u010dka...",
  Name: "Ime",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id treba po\u010dinjati slovom, a nakon toga slijede samo slova, brojevi, crtice, to\u010dke, dvoto\u010dke i podvlake.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Postoje ne pohranjene izmjene, jeste li sigurni da \u017eelite oti\u0107i?",
  "Restore last draft": "Vrati posljednju skicu",
  "Special character...": "Poseban znak...",
  "Source code": "Izvorni kod",
  "Insert/Edit code sample": "Umetni/Uredi primjer k\u00f4da",
  Language: "Jezik",
  "Code sample...": "Primjerak k\u00f4da...",
  "Color Picker": "Izabira\u010d boja",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "S lijeva na desno",
  "Right to left": "S desna na lijevo",
  "Emoticons...": "Emotikoni...",
  "Metadata and Document Properties": "Metapodaci i svojstva dokumenta",
  Title: "Naslov",
  Keywords: "Klju\u010dne rije\u010di",
  Description: "Opis",
  Robots: "Roboti pretra\u017eiva\u010da",
  Author: "Autor",
  Encoding: "Kodna stranica",
  Fullscreen: "Cijeli ekran",
  Action: "Action",
  Shortcut: "Shortcut",
  Help: "Help",
  Address: "Address",
  "Focus to menubar": "Focus to menubar",
  "Focus to toolbar": "Focus to toolbar",
  "Focus to element path": "Focus to element path",
  "Focus to contextual toolbar": "Focus to contextual toolbar",
  "Insert link (if link plugin activated)":
    "Insert link (if link plugin activated)",
  "Save (if save plugin activated)": "Save (if save plugin activated)",
  "Find (if searchreplace plugin activated)":
    "Find (if searchreplace plugin activated)",
  "Plugins installed ({0}):": "Plugins installed ({0}):",
  "Premium plugins:": "Premium plugins:",
  "Learn more...": "Learn more...",
  "You are using {0}": "You are using {0}",
  Plugins: "Dodaci",
  "Handy Shortcuts": "Korisni pre\u010daci",
  "Horizontal line": "Horizontalna linija",
  "Insert/edit image": "Umetni/izmijeni sliku",
  "Image description": "Opis slike",
  Source: "Izvor",
  Dimensions: "Dimenzije",
  "Constrain proportions": "Zadr\u017ei proporcije",
  General: "Op\u0107enito",
  Advanced: "Napredno",
  Style: "Stil",
  "Vertical space": "Okomit razmak",
  "Horizontal space": "Horizontalan razmak",
  Border: "Rub",
  "Insert image": "Umetni sliku",
  "Image...": "Slika...",
  "Image list": "Image list",
  "Rotate counterclockwise": "Rotiraj lijevo",
  "Rotate clockwise": "Rotiraj desno",
  "Flip vertically": "Obrni vertikalno",
  "Flip horizontally": "Obrni horizontalno",
  "Edit image": "Uredi sliku",
  "Image options": "Opcije slike",
  "Zoom in": "Pove\u0107aj",
  "Zoom out": "Smanji",
  Crop: "Obre\u017ei",
  Resize: "Promjeni veli\u010dinu",
  Orientation: "Orijentacija",
  Brightness: "Svjetlina",
  Sharpen: "Izo\u0161travanje",
  Contrast: "Kontrast",
  "Color levels": "Razine boje",
  Gamma: "Gamma",
  Invert: "Invertiraj",
  Apply: "Primijeni",
  Back: "Natrag",
  "Insert date/time": "Umetni datum/vrijeme",
  "Date/time": "Datum/vrijeme",
  "Insert/Edit Link": "Umetni/uredi poveznicu",
  "Insert/edit link": "Umetni/izmijeni poveznicu",
  "Text to display": "Tekst za prikaz",
  Url: "Url",
  "Open link in...": "Otvori poveznicu u...",
  "Current window": "Trenuta\u010dni prozor",
  None: "Ni\u0161ta",
  "New window": "Novi prozor",
  "Remove link": "Ukloni poveznicu",
  Anchors: "Kra\u0107e poveznice",
  "Link...": "Poveznica...",
  "Paste or type a link": "Zalijepi ili upi\u0161i link",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Izgleda da je URL koji ste upisali e-mail adresa. \u017delite li dodati obavezan mailto: prefiks?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Izgleda da je URL koji ste upisali vanjski link. \u017delite li dodati obavezan http:// prefiks?",
  "Link list": "Link list",
  "Insert video": "Umetni video",
  "Insert/edit video": "Umetni/izmijeni video",
  "Insert/edit media": "Umetni/uredi mediju",
  "Alternative source": "Alternativni izvor",
  "Alternative source URL": "URL alternativnog izvora",
  "Media poster (Image URL)": "Medijski poster (URL slike)",
  "Paste your embed code below:": "Umetnite va\u0161 kod za ugradnju ispod:",
  Embed: "Ugradi",
  "Media...": "Mediji...",
  "Nonbreaking space": "Neprekidaju\u0107i razmak",
  "Page break": "Prijelom stranice",
  "Paste as text": "Zalijepi kao tekst",
  Preview: "Pregled",
  "Print...": "Ispi\u0161i...",
  Save: "Spremi",
  Find: "Tra\u017ei",
  "Replace with": "Zamijeni s",
  Replace: "Zamijeni",
  "Replace all": "Zamijeni sve",
  Previous: "Prethodno",
  Next: "Slijede\u0107i",
  "Find and replace...": "Prona\u0111i i zamijeni...",
  "Could not find the specified string.":
    "Tra\u017eeni tekst nije prona\u0111en",
  "Match case": "Pazi na mala i velika slova",
  "Find whole words only": "Prona\u0111i samo cijele rije\u010di",
  "Spell check": "Provjera pravopisa",
  Ignore: "Zanemari",
  "Ignore all": "Zanemari sve",
  Finish: "Zavr\u0161i",
  "Add to Dictionary": "Dodaj u rje\u010dnik",
  "Insert table": "Umetni tablicu",
  "Table properties": "Svojstva tablice",
  "Delete table": "Izbri\u0161i tablicu",
  Cell: "Polje",
  Row: "Redak",
  Column: "Stupac",
  "Cell properties": "Svojstva polja",
  "Merge cells": "Spoji polja",
  "Split cell": "Razdvoji polja",
  "Insert row before": "Umetni redak prije",
  "Insert row after": "Umetni redak nakon",
  "Delete row": "Izbri\u0161i redak",
  "Row properties": "Svojstva redka",
  "Cut row": "Izre\u017ei redak",
  "Copy row": "Kopiraj redak",
  "Paste row before": "Zalijepi redak prije",
  "Paste row after": "Zalijepi redak nakon",
  "Insert column before": "Umetni stupac prije",
  "Insert column after": "Umetni stupac nakon",
  "Delete column": "Izbri\u0161i stupac",
  Cols: "Stupci",
  Rows: "Redci",
  Width: "\u0160irina",
  Height: "Visina",
  "Cell spacing": "Razmak izme\u0111u polja",
  "Cell padding": "Razmak unutar polja",
  "Show caption": "Prika\u017ei natpis",
  Left: "Lijevo",
  Center: "Sredina",
  Right: "Desno",
  "Cell type": "Vrsta polja",
  Scope: "Doseg",
  Alignment: "Poravnanje",
  "H Align": "H Poravnavanje",
  "V Align": "V Poravnavanje",
  Top: "Vrh",
  Middle: "Sredina",
  Bottom: "Dno",
  "Header cell": "Polje zaglavlja",
  "Row group": "Grupirani redci",
  "Column group": "Grupirani stupci",
  "Row type": "Vrsta redka",
  Header: "Zaglavlje",
  Body: "Sadr\u017eaj",
  Footer: "Podno\u017eje",
  "Border color": "Boja ruba",
  "Insert template...": "Umetni predlo\u017eak...",
  Templates: "Predlo\u0161ci",
  Template: "Predlo\u017eak",
  "Text color": "Boja teksta",
  "Background color": "Boja pozadine",
  "Custom...": "Prilago\u0111eno...",
  "Custom color": "Prilago\u0111ena boja",
  "No color": "Bez boje",
  "Remove color": "Ukloni boju",
  "Table of Contents": "Sadr\u017eaj",
  "Show blocks": "Prika\u017ei blokove",
  "Show invisible characters": "Prika\u017ei nevidljive znakove",
  "Word count": "Broj rije\u010di",
  Count: "Broj",
  Document: "Dokument",
  Selection: "Odabir",
  Words: "Rije\u010di",
  "Words: {0}": "Rije\u010di: {0}",
  "{0} words": "{0} rije\u010d(i)",
  File: "Datoteka",
  Edit: "Izmijeni",
  Insert: "Umetni",
  View: "Pogled",
  Format: "Oblikuj",
  Table: "Tablica",
  Tools: "Alati",
  "Powered by {0}": "Omogu\u0107uje {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Pritisni ALT-F9 za izbornik. Pritisni ALT-F10 za alatnu traku. Pritisni ALT-0 za pomo\u0107",
  "Image title": "Naslov slike",
  "Border width": "\u0160irina granice",
  "Border style": "Stil granice",
  Error: "Pogre\u0161ka",
  Warn: "Upozori",
  Valid: "Valjano",
  "To open the popup, press Shift+Enter":
    "Da biste otvorili sko\u010dni prozor, pritisnite Shift\u00a0+\u00a0Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Podru\u010dje oboga\u0107enog teksta. Pritisnite ALT-0 za pomo\u0107.",
  "System Font": "Font sustava",
  "Failed to upload image: {0}": "U\u010ditavanje slike nije uspjelo: {0}",
  "Failed to load plugin: {0} from url {1}":
    "U\u010ditavanje dodatka nije uspjelo: {0} s URL-a {1}",
  "Failed to load plugin url: {0}": "U\u010ditavanje dodatka nije uspjelo: {0}",
  "Failed to initialize plugin: {0}": "Pokretanje dodatka nije uspjelo: {0}",
  example: "primjer",
  Search: "Tra\u017ei",
  All: "Svi",
  Currency: "Valuta",
  Text: "Tekst",
  Quotations: "Navodnici",
  Mathematical: "Matemati\u010dki",
  "Extended Latin": "Pro\u0161ireni latinski",
  Symbols: "Simboli",
  Arrows: "Strelice",
  "User Defined": "Korisni\u010dki definirano",
  "dollar sign": "znak za dolar",
  "currency sign": "znak za valutu",
  "euro-currency sign": "znak za valutu \u2013 euro",
  "colon sign": "znak za kolon",
  "cruzeiro sign": "znak za cruzeiro",
  "french franc sign": "znak za francuski franak",
  "lira sign": "znak za liru",
  "mill sign": "znak za mill",
  "naira sign": "znak za nairu",
  "peseta sign": "znak za pezetu",
  "rupee sign": "znak za rupiju",
  "won sign": "znak za von",
  "new sheqel sign": "znak za novi \u0161ekel",
  "dong sign": "znak za dong",
  "kip sign": "znak za kip",
  "tugrik sign": "znak za tugrik",
  "drachma sign": "znak za drahmu",
  "german penny symbol": "simbol za njema\u010dki peni",
  "peso sign": "znak za pezo",
  "guarani sign": "znak za gvarani",
  "austral sign": "znak za austral",
  "hryvnia sign": "znak za grivnju",
  "cedi sign": "znak za cedi",
  "livre tournois sign": "znak za livre tournois",
  "spesmilo sign": "znak za spesmilo",
  "tenge sign": "znak za tengu",
  "indian rupee sign": "znak za indijsku rupiju",
  "turkish lira sign": "znak za tursku liru",
  "nordic mark sign": "znak za nordijsku marku",
  "manat sign": "znak za manat",
  "ruble sign": "znak za rubalj",
  "yen character": "znak za jen",
  "yuan character": "znak za juan",
  "yuan character, in hong kong and taiwan":
    "znak za juan, u Hong Kongu i Tajvanu",
  "yen/yuan character variant one": "znak za jen/juan, prva varijanta",
  "Loading emoticons...": "U\u010ditavanje emotikona...",
  "Could not load emoticons": "Nije mogu\u0107e u\u010ditati emotikone",
  People: "Osobe",
  "Animals and Nature": "\u017divotinje i priroda",
  "Food and Drink": "Hrana i pi\u0107e",
  Activity: "Aktivnosti",
  "Travel and Places": "Putovanje i mjesta",
  Objects: "Predmeti",
  Flags: "Zastave",
  Characters: "Znakovi",
  "Characters (no spaces)": "Znakovi (bez razmaka)",
  "{0} characters": "{0} znakova",
  "Error: Form submit field collision.":
    "Pogre\u0161ka: sukob polja za podno\u0161enje obrasca.",
  "Error: No form element found.": "Pogre\u0161ka: nema elementa oblika.",
  Update: "A\u017euriraj",
  "Color swatch": "Uzorak boje",
  Turquoise: "Tirkizna",
  Green: "Zelena",
  Blue: "Plava",
  Purple: "Ljubi\u010dasta",
  "Navy Blue": "Mornarsko plava",
  "Dark Turquoise": "Tamnotirkizna",
  "Dark Green": "Tamnozelena",
  "Medium Blue": "Srednje plava",
  "Medium Purple": "Srednje ljubi\u010dasta",
  "Midnight Blue": "Pono\u0107no plava",
  Yellow: "\u017duta",
  Orange: "Naran\u010dasta",
  Red: "Crvena",
  "Light Gray": "Svijetlosiva",
  Gray: "Siva",
  "Dark Yellow": "Tamno\u017euta",
  "Dark Orange": "Tamnonaran\u010dasta",
  "Dark Red": "Tamnocrvena",
  "Medium Gray": "Srednje siva",
  "Dark Gray": "Tamnosiva",
  "Light Green": "Svjetlozelena",
  "Light Yellow": "Svjetlo\u017euta",
  "Light Red": "Svjetlocrvena",
  "Light Purple": "Svjetloljubi\u010dasta",
  "Light Blue": "Svjetloplava",
  "Dark Purple": "Tamnoljubi\u010dasta",
  "Dark Blue": "Tamnoplava",
  Black: "Crna",
  White: "Bijela",
  "Switch to or from fullscreen mode":
    "Prebacivanje u prikaz preko cijelog zaslona ili iz njega",
  "Open help dialog": "Otvori dijalo\u0161ki okvir za pomo\u0107",
  history: "povijest",
  styles: "stilovi",
  formatting: "oblikovanje",
  alignment: "poravnanje",
  indentation: "uvlaka",
  "permanent pen": "trajna olovka",
  comments: "komentari",
  "Format Painter": "Prenositelj oblikovanja",
  "Insert/edit iframe": "Umetni/uredi iframe oznaku",
  Capitalization: "Velika slova",
  lowercase: "mala slova",
  UPPERCASE: "VELIKA SLOVA",
  "Title Case": "Pisanje naslova",
  "Permanent Pen Properties": "Trajna svojstva olovke",
  "Permanent pen properties...": "Trajna svojstva olovke...",
  Font: "Font",
  Size: "Veli\u010dina",
  "More...": "Vi\u0161e...",
  "Spellcheck Language": "Jezik provjere pravopisa",
  "Select...": "Odaberi...",
  Preferences: "Postavke",
  Yes: "Da",
  No: "Ne",
  "Keyboard Navigation": "Navigacija na tipkovnici",
  Version: "Ina\u010dica",
  Anchor: "Sidro",
  "Special character": "Poseban znak",
  Color: "Boja",
  Emoticons: "Emotikoni",
  "Document properties": "Svojstva dokumenta",
  Image: "Slika",
  "Insert link": "Umetni poveznicu",
  Target: "Meta",
  Link: "Link",
  Poster: "Poster",
  Media: "Media",
  Print: "Ispis",
  Prev: "Prethodni",
  "Find and replace": "Prona\u0111i i zamijeni",
  "Whole words": "Cijele rije\u010di",
  Spellcheck: "Provjeri pravopis",
  Caption: "Natpis",
  "Insert template": "Umetni predlo\u017eak",
});
